import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-view-sample-detail',
  templateUrl: './view-sample-detail.component.html',
  styleUrls: ['./view-sample-detail.component.css']
})
export class ViewSampleDetailComponent implements OnInit {

  @Input() sampleTaskDetail:string =  undefined

  @Output()  viewSampleTaskDetailFinished= new EventEmitter<boolean>()
  constructor() { }

  ngOnInit(): void {
  }
  closeSampleTaskModal(){
    this.viewSampleTaskDetailFinished.emit(true)
  }
}

